import httpClient from '@/libs/http-client'

export function signIn(params) {
  const url = '/api/super/login'
  // params.password = encrypt(params.password, params.username)

  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function getToken() {
  const url = '/api/super/getToken'
  return httpClient.post(url).then(response => {
    return response.data
  })
}

const nullToQuote = (data) => {
  return !data ? '' : data
}

export function getCode(masterCode, groupCode, code) {
  const url = '/api/common/code'

  const data = {
    masterCode: nullToQuote(masterCode),
    groupCode: nullToQuote(groupCode),
    code: nullToQuote(code)
  }

  return httpClient.post(url, data).then(response => {
    return response.data.data.codes
  })
}

export function getGameCodes(masterCode, groupCode, code) {
  const url = '/api/common/code'

  const data = {
    masterCode: nullToQuote(masterCode),
    groupCode: nullToQuote(groupCode),
    code: nullToQuote(code)
  }

  return httpClient.post(url, data).then(response => {
    return response.data.data.codes
  })
}

export function userDetail(params) {
  const url = '/api/super/member/detail'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

